import {AbstractFilter} from './AbstractFilter';
import {FilterValueInterface} from 'modules/spravochnik/dt-front-page-generator/src/Entity/Filter/Value/FilterValueInterface';
import {Interval, IntervalMode, Value} from '@app/vue/DatePicker/src';

class DateTimeValue implements FilterValueInterface {

    private _dateTimeValue: Value|null = null;

    setDateTimeValue(value: Value): void {
        this._dateTimeValue = value;
    }

    getDateTimeValue(): Value|null {
        return this._dateTimeValue;
    }

    countValues(): number {
        return this._dateTimeValue ? 1 : 0;
    }

    notEmpty(): boolean {
        return this._dateTimeValue instanceof Value;
    }

    clear() {
        this._dateTimeValue = null;
    }

    toServerParam(): any {
        return this._dateTimeValue?.interval;
    }

    setGetParam(value: any): void {
        if (typeof value !== 'string') {
            return;
        }

        if (value === '-1') {
            this._dateTimeValue = new Value();
            this._dateTimeValue.mode = IntervalMode.ALL_TIME;
        }

        const regex = /(?<start>\d+)\|(?<end>\d+)\|(?<mode>(.*))/gm;
        const result = regex.exec(value);
        console.log(result, value);
        if (!result) {
            return;
        }

        const mode = String(result.groups['mode']) as IntervalMode;
        if (!(<any>Object).values(IntervalMode).includes(mode)) {
            return;
        }

        this._dateTimeValue = new Value();
        this._dateTimeValue.mode = mode;
        this._dateTimeValue.interval = new Interval(
            new Date(parseInt(result.groups['start'], 10)),
            new Date(parseInt(result.groups['end'], 10)),
        )
    }

    toGetParam(): any {
        const value = this._dateTimeValue;
        if (value.mode === IntervalMode.ALL_TIME) {
            return -1;
        }

        if (value.interval) {
            return value.interval.start.getTime() + '|' + value.interval.end.getTime() + '|' + value.mode;
        }

        return null;
    }
}

export class DateTimeFilter extends AbstractFilter<DateTimeValue> {

    private _value: DateTimeValue|null;

    constructor(id: string, label: string) {
        super(id, label);
        this._value = new DateTimeValue();
    }

    hasValue(): boolean {
        return this._value.notEmpty();
    }

    get value(): DateTimeValue {
        return this._value;
    }

    set value(value: DateTimeValue) {
        this._value = value;
    }

    reset(): void {
        this._value.clear();
    }
}
